// core (MUI)
import {frFR as frFRCore} from '@mui/material/locale';
// data grid (MUI)
import {frFR as frFRDataGrid} from '@mui/x-data-grid/locales';
// date pickers (MUI)
import {frFR as frFRDate} from '@mui/x-date-pickers/locales';

// ----------------------------------------------------------------------

export const allLangs = [
  {
    value: 'fr',
    label: 'French',
    countryCode: 'FR',
    adapterLocale: 'fr',
    numberFormat: {code: 'fr-Fr', currency: 'EUR'},
    systemValue: {
      components: {...frFRCore.components, ...frFRDate.components, ...frFRDataGrid.components},
    },
  },
];

/**
 * Country code:
 * https://flagcdn.com/en/codes.json
 *
 * Number format code:
 * https://gist.github.com/raushankrjha/d1c7e35cf87e69aa8b4208a8171a8416
 */
